define('modules/common/controller/ModalNote',[], function() {
	var Controller = function(
		$scope,
		$modalInstance,
		testoNota) {

		$scope.testoNota = testoNota;

		$scope.closeModal = function() {
			$modalInstance.dismiss();
		};

	};

	return [
		"$scope",
		"$modalInstance",
		"testoNota",
		Controller
	];
});
